import styled from 'styled-components';

const Container = styled.div``;
const Heading = styled.h2`
  font-weight: 100;
  font-size: 24px;
  margin-bottom: 10px;
`;
const Info = styled.p`
  display: flex;
  align-items: center;
`;
const Bold = styled.span`
  font-weight: 700;
  margin: 0;
  margin-left: 5px;
`;
export { Container, Heading, Info, Bold };
